export const RoutesEnum = {
  CATEGORIES: '/categories',
  SERVICES: '/services',
  STORES: '/stores',
  TIME_SLOTS: '/time-slots',
  INFORMATIONS: '/informations',
  AUTH: '/auth',
  AUTH_REDIRECT: '/auth/redirect',
  AUTH_FED_TOKEN: '/auth/fed-token',
  AUTH_FED_TOKEN_ERROR: '/auth/fed-token/error',
  CONFIRM: '/confirm',
  SUCCESS: '/success',
  ORDER_CANCELLED: '/orders/[id]/cancelled',
  ORDER: '/orders/[id]',
  ORDERS: '/orders',
};
